























import {
  computed,
  defineComponent,
  Ref,
  ref,
  toRefs
} from '@nuxtjs/composition-api'
import { formFieldProps } from '~/constants/form'
import { useClassifiedForm } from '~/compositions/form'
import { dateIsValid, format, parseDate, parseISODate } from '~/utils/date'
import { SIMPLE_DATE_FORMAT } from '~/constants/date'
import FieldError from '~/components/car/classifieds/form/fieldsets/fields/FieldError.vue'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import CDatepickerInput from '~/components/shared/configurable/date/CDatepickerInput.vue'

export default defineComponent({
  components: { FieldError, CDatepickerInput },
  props: formFieldProps,
  setup(props) {
    const { name } = toRefs(props)

    const selectedDate = ref<Date | null>(null)
    const today = ref(new Date())

    function onValue(v: Ref<any>) {
      if (v.value) {
        const parsedDate = parseDate(v.value, SIMPLE_DATE_FORMAT)
        // checking for parse format here since the frontend handles the date as d/M/yyyy but the backend returns
        // it as ISO
        if (dateIsValid(parsedDate)) {
          selectedDate.value = parsedDate
        } else {
          selectedDate.value = parseISODate(v.value)
        }
      } else {
        selectedDate.value = null
      }
    }

    const { valueChanged, error } = useClassifiedForm(props, { onValue })

    function handleDateInput(date: Date) {
      const formattedDate = format(date, SIMPLE_DATE_FORMAT)
      valueChanged(name.value, formattedDate)
    }

    const minDate = computed(() => today.value)

    function handleClearButtonClick() {
      selectedDate.value = null
      valueChanged(name.value, selectedDate.value)
    }

    return {
      faTimes,
      minDate,
      handleDateInput,
      selectedDate,
      error,
      handleClearButtonClick
    }
  }
})
